"use client";

import { HorizontalGrid, ListContainer, ListItem } from "@/components/list/dynamic-list";
import { TUser } from "@/types/types";

type UserCreatedCoursesListProps = {
  user: TUser;
};

export default function UserCreatedCoursesList({ user }: UserCreatedCoursesListProps) {
  const isTeacher = user._count.createdCourses > 0;

  return (
    <>
      {isTeacher ? (
        <ListContainer
          title="Created courses"
          variant="transparent"
          isEmpty={user.createdCourses.length === 0}
          emptyMessage="No courses yet"
        >
          <HorizontalGrid
            items={user.createdCourses}
            renderItem={(course) => (
              <ListItem
                title={course.title}
                subtitle={course.subtitle || ""}
                thumbnailUrl={course.thumbnailImage?.url || ""}
                href={`/course/${course.slug}`}
                variant="grid"
              />
            )}
          />
        </ListContainer>
      ) : null}
    </>
  );
}
